let accessToken: string = localStorage.getItem('accessToken') || ""
let refreshAccessToken: string = localStorage.getItem('refreshAccessToken') || ""

const setAccessToken = (newAccessToken: string) => {
  accessToken = newAccessToken
  localStorage.setItem('accessToken', newAccessToken)
}

const getAccessToken = (): string => {
  return accessToken
}

const setRefreshAccessToken = (newRefreshAccessToken: string) => {
  refreshAccessToken = newRefreshAccessToken
  localStorage.setItem('refreshAccessToken', newRefreshAccessToken)
}

const getRefreshAccessToken = (): string => {
  return refreshAccessToken
}

export {
  setAccessToken, getAccessToken,
  setRefreshAccessToken, getRefreshAccessToken
}
